import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-validation-messages',
  templateUrl: './validation-messages.component.html'
})
export class ValidationMessagesComponent implements OnInit {
  @Input() formName: UntypedFormControl;
  @Input() message;
  @Input() submitted: boolean;
  constructor() { }

  ngOnInit() {
  }

}
